angular.module('directives.dashboard').directive('wgtOrderAutoOrders', ['DashboardApiService', '$state', '$window',
        function (DashboardApiService, $state, $window) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtOrderAutoOrders/wgtOrderAutoOrders.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.filter = {
                        show: false,
                        businessArea: { id: -1, name: ' ' },
                        brand: { id: -1, name: ' ' },
                        orderType: "all"
                    };
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data.autoOrderData;
                                $scope.originalWidgetData = response.data.autoOrderData;
                                $scope.hideTooltip = response.data.hideTooltip;
                                $scope.distinctBrandIds = response.data.distinctBrandIds;
                                $scope.distinctBusinessAreaIds = response.data.distinctBusinessAreaIds;
                                $scope.isLoaded = true;
                                $scope.hasError = false;

                                $scope.$watch(function() { return $scope.filter.businessArea }, function(newValue, oldValue) {
                                    $scope.filterData();
                                }, true);
                                $scope.$watch(function() { return $scope.filter.brand }, function(newValue, oldValue) {
                                    $scope.filterData();
                                }, true);
                                $scope.$watch(function() { return $scope.filter.orderType }, function(newValue, oldValue) {
                                    $scope.filterData();
                                }, true);
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };

                    $scope.filterData = function () {
                        var newWidgetData = angular.copy($scope.originalWidgetData);

                        if($scope.filter.businessArea.id !== undefined && $scope.filter.businessArea.id !== -1){
                            newWidgetData = newWidgetData.filter(x => x.businessAreaIds.filter(y => y.id === $scope.filter.businessArea.id).length > 0);
                        }

                        if($scope.filter.brand.id !== undefined && $scope.filter.brand.id !== -1){
                            newWidgetData = newWidgetData.filter(x => x.brandIds.filter(y => y.id === $scope.filter.brand.id).length > 0);
                        }

                        if(newWidgetData !== undefined){
                            $scope.widgetData = newWidgetData.filter(x => $scope.filter.orderType === "all" || x.orderSystemType === $scope.filter.orderType);
                        }

                        /*
                        $scope.distinctBrandIds = [];
                        $scope.distinctBusinessAreaIds = [];

                        _.forEach($scope.originalWidgetData, function(data){
                            _.forEach(data.businessAreaIds, function(ba){
                                if($scope.distinctBusinessAreaIds.filter(x => x.id === ba.id).length === 0){
                                    $scope.distinctBusinessAreaIds.push(ba);
                                }
                            });
                            _.forEach(data.brandIds, function(b){
                                if($scope.distinctBrandIds.filter(x => x.id === b.id).length === 0){
                                    $scope.distinctBrandIds.push(b);
                                }
                            });
                        });*/
                    };

                    $scope.goToOrder = function (orderId) {
                        if(orderId !== undefined){
                            var href = $state.href('order.ordersearch', { orderId: orderId });;
                            $window.open(href);
                        }
                    };
                    $scope.orderAutoOrder_OrderBy = 'orderCreatedDate';
                    $scope.orderAutoOrder_Reverse = true;
                    $scope.changeSortOrder = function (objectName) {
                        if($scope.orderAutoOrder_OrderBy === objectName){
                            if($scope.orderAutoOrder_Reverse){
                                $scope.orderAutoOrder_OrderBy = undefined;
                                $scope.orderAutoOrder_Reverse = undefined;
                            }
                            else{
                                $scope.orderAutoOrder_Reverse = true;
                            }
                        }
                        else{
                            $scope.orderAutoOrder_OrderBy = objectName;
                            $scope.orderAutoOrder_Reverse = false;
                        }
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
